import Badge from 'components/commons/badge'

export const OPTION_BULK = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
}

export const DEFAULT_QUERY = {
    page: 1,
    limit: 20,
    search: '',
    order_by: null,
    order_type: null,
}

export const TABLE_TAX_PLANNING_LIST = {
    name: 'Tax Planning List',
    column: [
        {
            name: 'Name',
            key: 'full_name',
            className: 'font-medium',
        },
        {
            name: 'NIP',
            key: 'employee_id_number',
        },
        {
            name: 'Job Title',
            key: 'job_title_name',
        },
        {
            name: 'Tax Planning Status',
            key: 'tax_planning_status',
            render: ({ value }) => <Badge type={value ? 'active' : 'inactive'} title={value ? 'active' : 'inactive'} />,
        },
    ],
}
